export default __webpack_public_path__ + "static/media/10.485aa23e.jpg";